<template>
    <div>
        <h1 class="display-heading">Reset Password</h1>

        <form @submit.prevent="submitForgotPassword">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group required">
                        <label>Password</label>

                        <input
                            type="password"
                            name="password"
                            data-vv-validate-on="blur"
                            placeholder="Create a New Password"
                            v-model="form.password"
                            v-validate="'required'"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('password')
                            }"
                            ref="passwordRef"
                        />

                        <div
                            v-show="validationErrors.has('password')"
                            class="invalid-feedback"
                        >{{ validationErrors.first('password') }}</div>
                    </div>

                    <div class="form-group required">
                        <label>Confirm Password</label>

                        <input
                            type="password"
                            name="repeatPassword"
                            data-vv-validate-on="blur"
                            placeholder="Confirm Your New Password"
                            v-model="form.repeatPassword"
                            v-validate="'required|confirmed:passwordRef'"
                            data-vv-as="password"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('repeatPassword')
                            }"
                        />

                        <div
                            v-show="validationErrors.has('repeatPassword')"
                            class="invalid-feedback"
                        >{{ validationErrors.first('repeatPassword') }}</div>
                    </div>
                </div>
            </div>

            <popup-modal
                ref="popupModalInvalid"
                :hasCloseButton="false"
                title="Invalid Request"
            >
                <template slot="content">
                    <p>
                        Invalid reset password request. Please try again.
                    </p>
                </template>
                <template slot="footer">
                    <button
                        type="button"
                        class="btn btn-primary btn-primary-insv"
                        @click="backToLogin"
                    >Okay</button>
                </template>
            </popup-modal>

            <popup-modal
                ref="popupModalSuccess"
                :hasCloseButton="false"
                title="Password Updated!"
            >
                <template slot="content">
                    <p>
                        Successfully updated your password!.
                    </p>
                    <p>
                        Login now to continue.
                    </p>
                </template>
                <template slot="footer">
                    <button
                        type="button"
                        class="btn btn-primary btn-primary-insv"
                        @click="backToLoginSuccess"
                    >Login</button>
                </template>
            </popup-modal>

            <button
                @click="submitForgotPassword"
                class="btn btn-primary btn-primary-insv mr-2"
                type="button"
            >Reset My Password</button>
            <router-link class="btn btn-secondary" :to="{'name': 'login'}">Back to Login</router-link>
        </form>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
export default {
    'name': 'ForgotPassword',
    'components': {
        popupModal
    },
    'computed': {
        userId () {
            return (this.$route.query && this.$route.query.userId) ? this.$route.query.userId : '';
        },
        token () {
            return (this.$route.query && this.$route.query.token) ? this.$route.query.token : '';
        }
    },
    data () {
        return {
            'form': {
                'password': '',
                'repeatPassword': ''
            }
        };
    },
    mounted () {
        if (this.userId && this.token) {
            this.axios.get('Account/VerifyResetPasswordToken', {
                'params': {
                    'userId': this.userId,
                    'token': this.token
                }
            }).catch(() => {
                this.$refs.popupModalInvalid.show();
            });
        } else {
            this.$refs.popupModalInvalid.show();
        }
    },
    'methods': {
        submitForgotPassword () {
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    // create reset password request in DB
                    this.axios
                        .post('Account/ResetPassword', {
                            'userId': this.userId,
                            'token': this.token,
                            'password': this.form.password
                        })
                        .then(() => {
                            this.$refs.popupModalSuccess.show();
                        })
                        .catch(() => {
                            this.$refs.popupModalInvalid.show();
                        });
                }
            });
        },
        backToLogin () {
            this.$refs.popupModalInvalid.hide().then(() => {
                this.$router.push({ 'name': 'login' });
            });
        },
        backToLoginSuccess () {
            this.$refs.popupModalSuccess.hide().then(() => {
                this.$router.push({ 'name': 'login' });
            });
        },
        dismissPopup () {
            this.$refs.popupModalInvalid.hide();
        }
    }
};
</script>

<style>
</style>
